import React from 'react';
import { createPortal } from 'react-dom';
import styles from './styles.module.scss';

interface ModalProps {
  onClose: () => void;
  children: React.ReactNode;
  zIndex?: number;
  hideCloseButton?: boolean;
}

const Modal: React.FC<ModalProps> = ({
    onClose, children, zIndex = 999, hideCloseButton = false 
}) => {
    return createPortal(
        <div className={styles["modal-overlay"]} onClick={onClose} style={{ zIndex }}>
            <div className={styles["modal-content"]} onClick={e => e.stopPropagation()}>
                {!hideCloseButton && (
                    <button className={styles["modal-close"]} onClick={onClose} aria-label="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M16.1177 3.88245L3.88232 16.1178M3.88232 3.88245L16.1177 16.1178" stroke="#6F6C8F" stroke-width="1.41177" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                )}
                {children}
            </div>
        </div>
        , document.body
    );
};

export { Modal };
export default Modal; 